import { render, staticRenderFns } from "./signatureIPVDetails.vue?vue&type=template&id=ff71e9ac&scoped=true&"
import script from "./signatureIPVDetails.vue?vue&type=script&lang=js&"
export * from "./signatureIPVDetails.vue?vue&type=script&lang=js&"
import style0 from "./signatureIPVDetails.vue?vue&type=style&index=0&id=ff71e9ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff71e9ac",
  null
  
)

export default component.exports